import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import PlaceHolderAudio from "constants/placeholderMusic.mp3";

interface IProps {
  toggleAudio?: () => void;
  file?: File | string;
  getCurrentTime?: (time: number) => void;
}
const ToggleAudio = ({ toggleAudio, file, getCurrentTime }: IProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [loading, setLoading] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      const handlePlay = () => setIsPlaying(true);
      const handlePause = () => setIsPlaying(false);

      audio.addEventListener("play", handlePlay);
      audio.addEventListener("pause", handlePause);

      return () => {
        audio.removeEventListener("play", handlePlay);
        audio.removeEventListener("pause", handlePause);
      };
    }
  }, []);

  const toggle = () => {
    if (toggleAudio) {
      toggleAudio();
    } else {
      if (audioRef.current && !loading) {
        setLoading(true);
        if (!isPlaying) {
          audioRef.current
            .play()
            .then(() => {
              setIsPlaying(true);
            })
            .catch((error) => {
              console.error("Failed to play audio:", error);
            })
            .finally(() => {
              setLoading(false);
            });
        } else {
          audioRef.current.pause();
          setIsPlaying(false);
          setLoading(false);
        }
      }
    }
  };

  const onTimeUpdate = () => {
    if (getCurrentTime) {
      getCurrentTime(audioRef.current?.currentTime || 0);
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  }, [file]);

  return (
    <Container
      onClick={() => {
        toggle();
        setIsPlaying(!isPlaying);
      }}
    >
      {!toggleAudio && (
        <audio
          controls
          // onLoadedMetadata={handleLoadedMetadata}
          onTimeUpdate={onTimeUpdate}
          style={{ display: "none" }}
          ref={audioRef}
        >
          <source src={file || PlaceHolderAudio} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      )}

      {!isPlaying ? (
        <svg
          fill="#000000"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 163.861 163.861"
          xmlSpace="preserve"
          width={"50%"}
          height={"50%"}
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <path d="M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275 c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z"></path>{" "}
            </g>{" "}
          </g>
        </svg>
      ) : (
        <svg
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          width={"50%"}
          height={"50%"}
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path d="M7 1H2V15H7V1Z" fill="#000000"></path>{" "}
            <path d="M14 1H9V15H14V1Z" fill="#000000"></path>{" "}
          </g>
        </svg>
      )}
    </Container>
  );
};

export default ToggleAudio;

const Container = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background-color: ${Colors.yellow500};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
